// $(function() {
//     // TBC
//     var homeHero = jQuery('.home-hero');
// 	homeHero.height(homeHero.height());
// });
